/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import axios from 'axios';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
export const useCompanyStore = defineStore('companyStore', {
  state: () => {
    const {
      handleError
    } = useSnackbarHandler();
    return {
      handleError,
      companySettings: {},
      subscription: {},
      name: ''
    };
  },
  getters: {
    customFlagLabel: state => state.companySettings.labels?.customFlag || null
  },
  actions: {
    async loadMyCompany(forcereset = false) {
      try {
        if (Object.keys(this.companySettings).length > 0 && !forcereset) {
          return this.companySettings;
        }
        const response = await axios({
          url: '/me/company'
        });
        this.$patch({
          companySettings: response.data.settings,
          name: response.data.name,
          subscription: response.data.subscription
        });
        return this.companySettings;
      } catch (error) {
        // null, not {} — a firm can legitimately have empty settings, so an
        // empty object is not a usable failure signal for callers.
        this.handleError(error);
        return null;
      }
    },
    async updateMyCompany(company) {
      try {
        const response = await axios({
          url: `/me/company`,
          method: 'PUT',
          data: company
        });
        this.$patch({
          companySettings: response.data.settings,
          name: response.data.name
        });
        return response.data;
      } catch (error) {
        // Rethrows rather than resolving: callers such as CompanyAutoIDs and
        // LedesSettings set local state and toast success on the line after the
        // await, so resolving here would have them report a save that failed.
        //
        // No handleError — those callers already toast in their own catch, and
        // reporting here too would stack two snackbars on one failure. Reads
        // above do report, because they recover instead of rethrowing.
        throw error;
      }
    },
    async updateCompanyName(companyId, name) {
      try {
        const response = await axios({
          url: `/companies/${companyId}/name`,
          method: 'PUT',
          data: {
            name: name.trim()
          }
        });

        // Update the store state with the new name
        this.$patch({
          name: name.trim()
        });
        return response.data;
      } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to update company name');
      }
    }
  }
});